import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { FormSelectField } from '../../common/components/formFields';
import { getOrganizationLocations } from '../../dealers/DealersActions';
import { formatOrganizationLocation } from '../../helpers/formatOrganizationLocation';

function LocationsSelectField({ organizationId, ...props }) {
  const dispatch = useDispatch();
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (!organizationId) {
      setOptions([]);
      return;
    }

    dispatch(
      getOrganizationLocations(organizationId, (response) => {
        const locations = response?.data || [];
        setOptions(
          locations.map((location) => ({
            value: location.id,
            label: formatOrganizationLocation(location),
          })),
        );
      }),
    );
  }, [dispatch, organizationId]);

  return <FormSelectField {...props} options={options} />;
}

LocationsSelectField.defaultProps = {
  organizationId: null,
};

LocationsSelectField.propTypes = {
  organizationId: PropTypes.string,
};

export default LocationsSelectField;
